module.exports = __webpack_public_path__ + "31a995f3270beeafeece85c2f9cc1196.mp3";